import { androidPrinter } from './mealbill-android.mjs';

export function categoryItems(items, menu = []) {
  return items.map(item => {
    if (item.categoryId || item.categoryName) return item;
    const entry = menu.find(m => [item._id, item.id, item.itemId].some(id => id && [m._id, m.id].some(mid => String(mid) === String(id))));
    return entry ? { ...item, categoryId: entry.categoryId, categoryName: entry.categoryName } : item;
  });
}

export function planKotStations(items, rows, profiles, tokenSlip = false) {
  if (!Array.isArray(rows)) throw new Error('Invalid saved KOT mappings');
  const mappings = rows.filter(row => profiles[row.printer] && row.categories?.length);
  const groups = mappings.map(row => ({ printer: row.printer, label: `KOT Printer ${rows.indexOf(row) + 1}: ${row.categories.map(c => c.name || c.id).join(', ')}`, items: [] }));
  const fallback = { printer: 'kitchen', label: 'Default KOT printer', items: [] };
  for (const item of items) {
    let matched = false;
    mappings.forEach((row, i) => {
      if (row.categories.some(c => (c.id && item.categoryId && String(c.id) === String(item.categoryId)) || (c.name && item.categoryName && c.name === item.categoryName))) {
        groups[i].items.push(item); matched = true;
      }
    });
    if (!matched) fallback.items.push(item);
  }
  // No active station/default means the existing upstream Manager spool remains responsible.
  if (!profiles.kitchen && !mappings.length) return { destination: 'manager', groups: [] };
  if (!profiles.kitchen && (fallback.items.length || tokenSlip)) throw new Error('Select a default KOT printer for unmapped items and parcel token slips before printing.');
  const result = [fallback, ...groups].filter(g => g.items.length);
  if (tokenSlip) result.push({ printer: 'kitchen', label: 'Parcel token', items: [], tokenSlip: true });
  return { destination: 'direct', groups: result.map(g => ({ ...g, profile: profiles[g.printer] })) };
}

// Never resend a successful station. Timeouts halt the remainder because its state is unknown.
// Two jobs for the same Bluetooth/LAN printer need a gap: the printer is still
// closing the first connection, and an immediate second connect fails with
// "read failed, socket might closed".
const deviceKey = d => d && d.address ? `${d.transport}:${d.address}:${d.port || ''}` : '';
const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export async function sendKotJobs(jobs, send = receipt => androidPrinter.print(receipt), { sameDeviceDelayMs = 2500, sleep = wait } = {}) {
  const results = [];
  let paused = false;
  let lastDevice = '';
  for (const job of jobs) {
    if (paused) { results.push({ ...job, state: 'not-sent', message: 'Not sent after an earlier response timeout.' }); continue; }
    const device = deviceKey(job.receipt?.destination);
    if (device && device === lastDevice) await sleep(sameDeviceDelayMs);
    lastDevice = device;
    try {
      const result = await send(job.receipt);
      results.push({ ...job, state: 'sent', message: result.message || 'Data sent; check paper.' });
    } catch (error) {
      results.push({ ...job, state: error.result?.status === 'uncertain' || error.result?.code === 'RESPONSE_TIMEOUT' ? 'uncertain' : 'failed', message: error.message });
      paused = error.result?.code === 'RESPONSE_TIMEOUT';
    }
  }
  return results;
}
